import Button from "heroic-ui-library/dist/components/Button";
import Input from "heroic-ui-library/dist/components/Input";
import { useState } from "react";
import Loading from "react-loading";
import { apiClient } from "../../api/api-client";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";

export default function ChildCode({
  setloginType,
  hideChildCode,
  loginType,
}: {
  setloginType: (value: "child_code" | "otp") => void;
  loginType: "child_code" | "otp";
  hideChildCode: boolean;
}) {
  const [childCode, setChildCode] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const nav = useNavigate();

  const gotoParentPage = (parentCode: string = "") => {
    const parent_code_updated = (parentCode || Cookies.get("parent_code")) + "";
    nav(`${"/parent_code/" + parent_code_updated}`);
  };

  const submitChildCode = async () => {
    if (!childCode) return setError("Please enter child code");

    setIsLoading(true);

    const response = await apiClient.bindChildCode(childCode);

    if (response.code == 200) {
      gotoParentPage(response.data.parent_code);
    } else if (response.code == 400) {
      setError(response.msg);
    }

    setIsLoading(false);
  };

  return (
    <div>
      <h1 className="top-heading text-center mb-3">Login</h1>
      {!hideChildCode && (
        <>
          <div className="flex justify-center items-center mb-3">
            <div className="border-t-2 border-dotted border-gray-400 flex-1" />
            <div className="divider-text text-[1.2rem] font-acme px-3">
              Log in with
            </div>
            <div className="border-t-2 border-dotted border-gray-400 flex-1" />
          </div>
          <div className="flex space-x-4">
            <Button
              onClick={() => setloginType("child_code")}
              className="submit-btn"
              label="Child Code"
              btnType={loginType == "child_code" ? "orange" : "green"}
            />
            <Button
              onClick={() => setloginType("otp")}
              className="submit-btn"
              label="Phone Number"
              btnType={loginType == "otp" ? "orange" : "green"}
            />
          </div>
        </>
      )}
      <div className="w-full py-3 px-3 space-y-3">
        <Input
          className="text-lg w-full"
          value={childCode}
          onChange={(e) => {
            setChildCode(e.currentTarget.value);
            setError("");
          }}
          placeholder="Child Code"
        />
        {error && <p className="text-red-500 font-acme">{error}</p>}

        {!isLoading ? (
          <Button
            className="!mt-8 btn"
            onClick={submitChildCode}
            btnType="green"
            label="Submit"
          />
        ) : (
          <Loading type="spin" color="#002356" />
        )}
      </div>
    </div>
  );
}
